module.exports = __webpack_public_path__ + "static/media/wm_back.2efab253.png";